/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import {
	HStack,
	Box,
	IconButton,
	Avatar,
	Text,
	Icon,
	Flex,
	Image,
} from '@chakra-ui/react'
import Card from '../../components/card'
import FormCategorySelector from '../../components/form/form-category-selector'
import { useAuthContext } from '../../context/auth.context'
import { useLanguageContext } from '../../context/locale.context'
import { useLoadFormTagMappingList } from '../../hooks/form.hooks'
import { greeting } from '../../utils/common.util'
import bgImage from '../../assets/images/opaque_bgImage.png'
import SVGIcon from '../../assets/svgIcons'

const FORM_LEVEL = {
	LEVEL_ONE: 1,
	LEVEL_TWO: 2,
	LEVEL_THREE: 3,
}

const FormPanel = ({ onFormSelect, panelV, onClose, from = '' }) => {
	const {
		state: { authData },
	} = useAuthContext()

	const {
		state: { locale },
	} = useLanguageContext()
	const [data, setData] = useState({})
	const [tagsList, setTagsList] = useState({})
	const [formList, setFormList] = useState({})
	const [levelFlag, setLevelFlag] = useState(FORM_LEVEL.LEVEL_ONE)
	const [selectedTagType, setSelectedTagType] = useState({
		form_tag_type_id: 0,
	})
	const [selectedTag, setSelectedTag] = useState({ form_tag_id: 0 })

	const { mutate: formTagListMutate, isLoading } = useLoadFormTagMappingList()

	useEffect(() => {
		loadFormTagMappingList()
	}, [])

	useEffect(() => {
		loadFormTagMappingList()
	}, [selectedTagType, selectedTag, levelFlag])

	const onSuccess = res => {
		if (levelFlag === FORM_LEVEL.LEVEL_ONE) {
			setData(res[0])
		}
		if (levelFlag === FORM_LEVEL.LEVEL_TWO) {
			setTagsList(res[0])
			setFormList({})
		}
		if (levelFlag === FORM_LEVEL.LEVEL_THREE) {
			setFormList(res[0])
		}
	}

	const onSelectTagType = tagType => {
		setSelectedTagType(tagType)
		setSelectedTag(0)
		if (!!tagType?.form_flag_skip_form_tag) {
			setLevelFlag(FORM_LEVEL.LEVEL_THREE)
			setTagsList({})
		} else {
			setLevelFlag(FORM_LEVEL.LEVEL_TWO)
		}
	}

	const onSelectTag = tag => {
		setSelectedTag(tag)
		setLevelFlag(FORM_LEVEL.LEVEL_THREE)
	}

	const loadFormTagMappingList = () => {
		formTagListMutate(
			{
				page_start: 0,
				page_limit: 100,
				tag_type_id: selectedTagType.form_tag_type_id,
				tag_id: selectedTag.form_tag_id || 0,
				flag: from === 'gantt' ? 4 : 3,
				flag_tag_enabled: authData.organization_flag_enable_form_tag,
				level_flag: levelFlag,
			},
			{
				onSuccess,
				onError: err => {
					console.log('error occurred', err)
				},
			}
		)
	}
	return (
		<Card
			h='calc(100vh - 100px)'
			boxShadow='none'
			backgroundRepeat='no-repeat'
			backgroundPosition='center'
			backgroundSize='cover'
			backgroundColor='#bbbbbb40'
			backgroundImage={`url(${bgImage})`}
			pr='0'
		>
			<>
				<Flex
					color='#000000'
					fontSize='15px'
					fontWeight={500}
					alignItems='center'
					cursor='pointer'
					bg='#FFFFFF'
					h='60px'
					mt='-2'
					ml='-2'
				>
					{/* <Image
						src={backArrowIcon}
						alt='backArrow icon'
						display='inline-block'
						cursor='pointer'
						onClick={() => {
							onClose()
						}}
						ml='4'
						mr='4'
					/> */}
					<Box mr='16px' ml='16px' onClick={() => {
							onClose()
						}} display='inline-block'
						cursor='pointer'>
					<SVGIcon
							iconName='BackArrowGreenSvg'
							svgProps={{
								width: '12',
								height: '20',
								viewBox: '0 0 12 20',
							}}
							// pathProps={{ fill: '#009B76' }}
						/>
						</Box>
					{locale['Start Request']}
				</Flex>

				<Box overflowY='auto' h='calc(100% - 60px)'>
					<FormCategorySelector
						list={data}
						tagsList={tagsList}
						formList={formList}
						isLoading={isLoading}
						onSelect={onSelectTagType}
						onSelectTag={onSelectTag}
						selectedTag={selectedTag}
						selectedTagType={selectedTagType}
						onFormSelect={onFormSelect}
						panelV={panelV}
						onClose={onClose}
					/>
				</Box>
			</>
		</Card>
	)
}

export default FormPanel
